import type { GlobalState } from 'little-state-machine';
import type { EnrichmentFromType } from '../../global';

export function setEnrichmentFrom(state: GlobalState, payload: EnrichmentFromType): GlobalState {
  return {
    ...state,
    enrichmentFrom: payload,
  };
}

export function clearEnrichmentFrom(state: GlobalState): GlobalState {
  return {
    ...state,
    enrichmentFrom: undefined,
  };
}
